<template>
  <div v-if="!isLoading">
    <section class="mb-8 flex items-center justify-between">
      <div class="flex items-center gap-x-8">
        <h1>{{ $t("channels") }}</h1>
        <BaseSearch @on-searching="(newVal) => filterText = newVal" />
      </div>
      <BaseButton @click="handleNewChannel">{{ $t("addNew") }}</BaseButton>
    </section>
    <BaseDataList
      class="space-y-6"
      :tot-data="filteredData.length"
      :is-searching="!!filterText"
    >
      <ChannelCard
        v-for="channel in filteredData"
        v-bind="channel"
        :key="channel.id"
      />
    </BaseDataList>
  </div>
  <BaseLoader v-else/>
</template>

<script setup>
import { ref, computed, onMounted } from "vue"
import { storeToRefs } from "pinia";
import { useI18n } from "vue-i18n";
import useModalStore from "@/stores/modal";
import useChannelStore from "@/stores/channel";
import ChannelCard from "@/components/channels/ChannelCard.vue";
import ChannelForm from "@/components/channels/ChannelForm.vue";
import { StatisticsService } from "@/api/services";

const modal = useModalStore();
const { t } = useI18n();
const filterText = ref("")
const isLoading = ref(false)

const filteredData = computed(() => {
  if(filterText && channelList.value){
    return channelList.value.filter((channel) => {
      if(channel.name.toLowerCase().includes(filterText.value.toLowerCase())) return true
      if(channel.type.toLowerCase().includes(filterText.value.toLowerCase())) return true
      let scopes = channel.Scopes
      if(scopes.find((scope) => {
        return scope.scopeString.replaceAll(":", "/").toLowerCase().includes(filterText.value.toLowerCase())
      })) return true
      return false
    })

  } else return channelList.value
})

const getChartData = async () => {
  try{
    for(let channel of channelList.value){
      let tempStats = await StatisticsService.getStatistics("channel", channel.id);
      Object.assign(channel, {chartOptions: tempStats.data.jsConfig})
    }
  } catch (e) {
    console.error(e)
  }
}

/**
 * Handle new organization event.
 */
function handleNewChannel() {
  modal.openModal({
    title: t("newChannel"),
    component: ChannelForm,
  });
}

/**
 * Filter scope list.
 */
const { channelList } = storeToRefs(useChannelStore());

onMounted(async () => {
  try{
    isLoading.value = true
    await getChartData()
  } catch (e) {
    console.log(error)
  } finally {
    isLoading.value = false
  }

})
</script>
